<main class="content d-flex flex-column vi-gap-24">
  <headline-with-icon [headline]="'APPOI.PROPOSAL_ACCEPTED.HEADLINE' | translate" [icon]="'success'">
  </headline-with-icon>
  <mat-card>
    <mat-card-content>
      <appointment-details
        [appointment]="appointment"
        [hideAddToCalendar]="false"
        [hideInfo]="true"
        [hideInstallation]="true"
        [hideLocation]="true"
        [settings]="settings">
      </appointment-details>
      <feedback-form-accepted
        (outputData)="receiveOutput($event)"
      ></feedback-form-accepted>
    </mat-card-content>
  </mat-card>
  <div *ngIf="embedModeEnabled" class="actions">
    <button (throttledClick)="closeFrameEvent()"
            [throttleTime]="5000"
            appPreventDoubleClick
            class="vi-button"
            color="primary"
            mat-flat-button>{{ 'APPOI.BUTTON.CLOSE' | translate }}
    </button>
  </div>
  <ng-container *ngIf="!embedModeEnabled">
    <viessmann-home-banner *ngIf="appointment.businessPartnerIsEndUser && settings.showLinkToViessmannHome"
                           [appointmentId]="appointment.id" [factoryId]="appointment.factoryId"
    ></viessmann-home-banner>
    <div *ngIf="!appointment.businessPartnerIsEndUser && settings.showLinkToHeatingSystemsOverview" class="actions">
      <button-heating-systems-overview [installation]="appointment.installation"></button-heating-systems-overview>
    </div>
  </ng-container>
</main>
